import React, {PureComponent} from 'react';
import {FastField, Field, FieldArray, ErrorMessage} from 'formik';
import {get, kebabCase} from 'lodash';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import FormRow from '../FormRow';
import ShuffledDetailExclusiveChoiceType from '../ShuffledDetailExclusiveChoiceType';
import CommonFields from './CommonFields';
import Error from '../../../Error';

class MultipleChoice1Type extends PureComponent {
    constructor(props) {
        super(props);
        this.onMinUpdate = this.onMinUpdate.bind(this);
        this.onMaxUpdate = this.onMaxUpdate.bind(this);
    }

    onMinUpdate(e) {
        const {name, form} = this.props;
        const values = get(form.values, name);
        const elementId = kebabCase(`#${name}.required.label`);
        const labelId = kebabCase(`#${name}.label-system-info-min`);
        const intVal = parseInt(e.currentTarget.value) || 0;
        if (intVal > 0 && values.required === false) {
            form.setFieldValue(`${name}.required`, true);
            document.querySelector(`#${elementId}`).classList.add('blinker');
            document.querySelector(`#${labelId}`).classList.remove('noshow');
            setTimeout(() => {
                document.querySelector(`#${elementId}`).classList.remove('blinker');
            }, 3000);
            setTimeout(() => {
                document.querySelector(`#${labelId}`).classList.add('noshow');
            }, 10000);
        }
        // this is needed or the value won't be updated to the field
        form.setFieldValue(`${name}.min`, intVal > 0 ? intVal : '');
    }

    onMaxUpdate(e) {
        const {name, form} = this.props;
        const intVal = parseInt(e.currentTarget.value) || 0;
        // this is needed or the value won't be updated to the field
        form.setFieldValue(`${name}.max`, intVal > 0 ? intVal : '');
    }

    render() {
        const {name, form, previousPages} = this.props;

        return (
            <>
                <CommonFields name={name} form={form} required={true} previousPages={previousPages} />
                <FormRow name={`${name}.min`} label={messages.surveys.form.label.min} size={3}>
                    <Field id={`${name}.min`} name={`${name}.min`} type="number" step="any" onChange={this.onMinUpdate}
                        className={classNames('form-control',
                            {error: get(form.errors, `${name}.min`) && get(form.touched, `${name}.min`)})} />
                    <ErrorMessage name={`${name}.min`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </FormRow>
                <div className="row">
                    <div id={kebabCase(`#${name}.label-system-info-min`)} className="col-md-12 label-system-info noshow">
                        <b><FormattedMessage {...messages.tooltips.autoSetRequired} /></b>
                    </div>
                </div>
                <FormRow name={`${name}.max`} label={messages.surveys.form.label.max} size={3}>
                    <FastField id={`${name}.max`} name={`${name}.max`} type="number" step="any" onChange={this.onMaxUpdate}
                        className={classNames('form-control',
                            {error: get(form.errors, `${name}.max`) && get(form.touched, `${name}.max`)})} />
                    <ErrorMessage name={`${name}.max`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </FormRow>
                <div className="form-group">
                    <h4>
                        &gt; <FormattedMessage {...messages.surveys.form.label.optionList} />
                    </h4>
                    <FieldArray name={`${name}.choices`} component={ShuffledDetailExclusiveChoiceType} />
                    <ErrorMessage name={`${name}.choices`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </div>
            </>
        );
    }
}
export default MultipleChoice1Type;
